export interface IUsage {
    amount: number;
    measuringUnit: EMeasuringUnit;
    quantity: number;
}

export enum EMeasuringUnit {
    SECOND = "SECOND",
    B = "B",
    EVENT = "EVENT",
}
